import React from "react";
import { Box, Text, Link } from "@chakra-ui/react";
const Not_Installed_Crm = () => {
  return (
    <Box mt="16px" className="form-intergrate-body">
      <Text
        fontSize="14px"
        //mb="2"
        w="612px"
        h="40px"
        color="#12344D"
        align="center"
      >
        Install the{" "}
        <Link
          color="#2C5CC5"
          fontWeight="600"
          href="https://wordpress.org/plugins/freshworks-crm/"
        >
          Freshworks CRM plugin{" "}
        </Link>
        to capture contacts directly to your Freshworks CRM
        <Text align="center">account.</Text>
      </Text>
    </Box>
  );
};

export default Not_Installed_Crm;
